<template>
  <div class="dropdown container">
    <div class="menu content">
      <a
        v-for="rate in playbackRates"
        :key="rate"
        class="rate"
        @click="handleClick(rate)"
        >
        {{ `${rate}x` }}
      </a>
    </div>
    <div class="dropdown title">
      {{ `${rate}x` }}
    </div>
  </div>
</template>

<script>
import { playbackRates } from '@/libraries/controlpanel/playbackRates'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'OwalSpeedPicker',
  computed: {
    ...mapGetters({
      rate: 'viewer/playbackRate',
    }),
    playbackRates () {
      return playbackRates
    },
  },
  methods: {
    ...mapMutations({
      updateRate: 'viewer/setPlaybackRate',
    }),
    handleClick (rate) {
      this.updateRate(rate)
    },
  },
}
</script>

<style scoped>

.dropdown.container {
  color: #EFF2F7;
  display: flex;
  flex-direction: column-reverse;
  padding: 0;
  margin: 0;
  height: 3.1428571429rem;
  z-index: 999;
}

.dropdown.container:hover {
  color: #f3f4f5;
  height: auto;
}

.dropdown.title {
  display: flex;
  align-items: center;
  height: 3.1428571429rem;
  font-size: 1.4rem;
  width: 4rem;
  z-index: 10000;
  font-weight: 600;
  color: #324057;
  margin: 0;
  align-content: center;
  justify-content: center;
  font-family: 'Lato', 'Avenir', 'Helvetica', sans-serif;
  border-top: 2px solid rgba(50, 64, 87, 0);
  transition: border-top 150ms ease;
}

.dropdown.container:hover .dropdown.title {
  border-top: 2px solid rgba(50, 64, 87, 1);
  transition: border-top 150ms ease;
}

.dropdown.container .menu.content {
  visibility: hidden;
  display: flex;
  position: absolute;
  margin: 0;
  /* box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.2); */
  z-index: 10000;
  cursor: pointer;
  height: 0;
  opacity: 0;
  padding-bottom: 3.1428571429rem;
  transform: translateY(8rem);
  transition: opacity 400ms ease, transform 300ms ease;
}

.dropdown.container:hover .menu.content{
  display: flex;
  position: absolute;
  visibility: initial;
  flex-direction: column;
  width: 4rem;
  /* background: #324057; */
  opacity: 1;
  height: auto;
  position: absolute;
  border-top-right-radius: 0.3571428571rem;
  border-top-left-radius: 0.3571428571rem;
  overflow: hidden;
  transform: translateY(0);
}

.dropdown.container .menu.content .rate {
  height: 3.1428571429rem;
  background: #f3f4f5;
  color: #324057;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin: 0;
  transition: color 300ms ease, background-color 300ms ease;
}

.dropdown.container .menu.content .rate:hover {
  background: #324057;
  color: #f3f4f5;
}

@media only screen and (max-width: 950px) and (orientation: portrait) {
  .dropdown.title {
    font-size: 1em;
  }
  .rate {
    font-size: .8rem;
  }
}

</style>
